module.exports = __webpack_public_path__ + "img/bnty.20beb800.svg";